import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import AutoplayVideo from '../../components/AutoplayVideo';
import MainBlockLayout from '../../components/MainBlockLayout';
import './MessageFromHT.css';

// Vertical (9:16) MP4 stored in the website's public/videos folder.
// After adding the file, set it to: `${process.env.PUBLIC_URL}/videos/message-from-ht.mp4`
// Leave empty to show a placeholder.
const VIDEO_URL = `${process.env.PUBLIC_URL}/videos/message-from-ht.mp4`;

// Key numbers strip. Texts live in locales/{en,ua}/message-from.json (stat_<name> and stat_<name>_label).
const STATS = [
  { key: 'since', value: '1955' },
  { key: 'welcomed' },
  { key: 'locations' },
  { key: 'children' },
];

// Extra paragraphs shown beside the video (fills the space next to the tall video)
const INTRO_MORE = ['since2022', 'usl'];
// Body paragraphs shown in order; each is a key in message-from.json.
const STORY = ['ambition', 'beyond', 'grateful', 'committees'];
const TOGETHER = ['together1', 'together2'];
const CLOSING = ['small_steps', 'shape_future'];

function MainBlock() {
  const { t } = useTranslation('messageFrom');

  return (
    <div className="messagePage">
      <h1 className="messageTitle">{t('title')}</h1>

      {/* Vertical video (left) + opening text with portrait (right) */}
      <div className="messageIntro">
        <div className="messageVideoWrap">
          <AutoplayVideo src={VIDEO_URL} />
        </div>
        <div className="messageText">
          <p>{t('intro1')}</p>
          <p>{t('intro2')}</p>
          {INTRO_MORE.map((key) => (
            <p key={key}>{t(key)}</p>
          ))}
        </div>
      </div>

      {/* Key numbers */}
      <div className="messageStats">
        {STATS.map(({ key, value }) => (
          <div className="messageStat" key={key}>
            <strong>{value || t(`stat_${key}`)}</strong>
            <span>{t(`stat_${key}_label`)}</span>
          </div>
        ))}
      </div>

      <div className="messageText messageStory">
        {STORY.map((key) => (
          <p key={key}>{t(key)}</p>
        ))}
      </div>

      {/* "Together" section in a soft panel, followed by the highlighted quote */}
      <div className="messagePanel">
        <h2>{t('together_title')}</h2>
        {TOGETHER.map((key) => (
          <p key={key}>{t(key)}</p>
        ))}
      </div>

      <blockquote className="messageQuote">{t('quote')}</blockquote>

      <div className="messageText messageStory">
        {CLOSING.map((key) => (
          <p key={key}>{t(key)}</p>
        ))}
      </div>

      {/* Call to action: text followed directly by the button */}
      <div className="messageCta">
        <p>{t('get_in_touch')}</p>
        <Link to="/contact-us" className="messageContactBtn">
          {t('contact_btn')}
        </Link>
      </div>

      <p className="messageText messageWish">{t('wish')}</p>

      {/* Sign-off */}
      <div className="messageSignature">
        <p className="messageSlava">{t('slava')}</p>
        <p className="messageSignName">{t('signature_name')}</p>
        <p className="messageSignRole">{t('signature_role')}</p>
      </div>
    </div>
  );
}

export default MainBlockLayout(MainBlock);
